import React from "react";
import { connect } from "react-redux";
import clsx from "clsx";

import { Grid, Container } from "@material-ui/core";
import useStyles from "./styles";

// components
import Toggle from "./Toggle";
import Report from "../../components/Report/Report";
//store
import * as actions from "../../store/actions/actionIndex";

function Dashboard(props) {
	var classes = useStyles();

	const rightfixedHeightPaper = clsx(classes.paper, classes.rightfixedHeight);

	return (
		<>
			<Grid container spacing={1}>
				<Container className={classes.GridStatus}>
					<h3 style={{ margin: 0 + "px" }}>Hello {props.agentName} !</h3>
					<Toggle />
				</Container>
				<Grid className={rightfixedHeightPaper} item xs={12} md={12} lg={12}>
					<Report />
				</Grid>
			</Grid>
		</>
	);
}

const mapStateToProps = (state) => {
	return {
		agentName: state.agentData.agentName,
		mode: state.agentData.dialerType,
		agentId: state.agentData.agentId,
		notes: state.agentNotes.notes,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		onAgentNotes: (agentId, notes, save) => dispatch(actions.agentNotes(agentId, notes, save)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
